import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss']
})
export class TitleComponent implements OnInit {

  @Input() width: string;
  @Input() title: string;
  @Input() spaceFromRight: string;
  displayPhone: boolean;
  isOnlineDesignPage: boolean;
  displayCoupon: boolean;
  constructor(private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.displayPhone = false;
    const currentPage = window.location.href;
    this.displayCoupon = false;
    this.isOnlineDesignPage = true;
    if (currentPage.indexOf('contactus') > -1) {
      this.displayPhone = true;
    }
    if (currentPage.indexOf('archonline_product_list') > -1 ) {
      this.displayCoupon = true;
    }
  }

}
